<div class="offers-table-row">
  <div class="offers-table-row__row">
    <div class="offers-table-row__logo">
      <img [src]="data.logoUri" alt="">
    </div>

    <div class="offers-table-row__cells">
      <div *ngFor="let tableOffer of data.tableOffers"
           class="offers-table-row__cells__cell">
        <app-offers-table-cell  [offer]="tableOffer.offer"
                                [columnKey]="tableOffer.key"
                                [selected]="offersTableService.isOfferSelected(tableOffer.offer, tableOffer.key)"
                                (confirmSelection)="offersTableService.confirmSelectedOffer()"
                                (select)="offersTableService.selectOffer($event)">
        </app-offers-table-cell>
      </div>
    </div>

    <div class="offers-table-row__button"
        [ngClass]="{'offers-table-row__button--expanded': expanded}">
      <button (click)="toggleOffers()"
              class="btn btn--clear-arrow">
        <ng-container *ngIf="expanded">
          <span>{{ 'OFFERS_TABLE.collapseOffers' | translate }}</span>
          <span class="material-icons">arrow_drop_up</span>
        </ng-container>
        <ng-container *ngIf="!expanded">
          <span>{{ 'OFFERS_TABLE.moreOffers' | translate }}</span>
          <span class="material-icons">arrow_drop_down</span>
        </ng-container>
      </button>
    </div>
  </div>

  <div *ngIf="expanded"
       class="offers-table-row__offers">
    <app-offers-list [offers]="data.offers"></app-offers-list>
  </div>
</div>
